module.exports = __webpack_public_path__ + "img/forte4.389f065c.jpeg";